export const atLeastOneUpperCaseCharacter = /^(.*?[A-Z]){1,}.*$/;
